module.exports = __webpack_public_path__ + "img/RedteaSIM 首图手机中文.eb07e2b7.png";